import { render, staticRenderFns } from "./ScientificWorkCertificate.vue?vue&type=template&id=705134d9&scoped=true&"
import script from "./ScientificWorkCertificate.vue?vue&type=script&lang=js&"
export * from "./ScientificWorkCertificate.vue?vue&type=script&lang=js&"
import style0 from "./ScientificWorkCertificate.vue?vue&type=style&index=0&id=705134d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705134d9",
  null
  
)

export default component.exports